import React, { useCallback, useEffect, useState ,useRef} from 'react';
import Avatar from '../../components/Avatar';
import {
  DotsIcon,
  VerifiedIcon,
  CopyLinkIcon,
  GridIcon,
  GridContentIcon,
  DownArrow,
  CloseModalIcon,
  BigXCloseBtn
} from '../../components/Icons';
import Loader from '../../components/Loader';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Button, Dropdown, ToggleButton } from 'react-bootstrap';
import { SETTINGS, USER_PROFILE } from '../../constants/routes';
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import Home from '../home/Home';
import { fetchProfile, fetchProfileSubs, toggleFollow, fetchProfileSubInfo } from '../../reducers/profile/profile.actions';
import {
  selectIsFetchingProfile,
  selectIsFollowingProfile,
  selectProfile,
  selectProfileLastActive,
} from '../../reducers/profile/profile.selectors';
import ReportModal from '../../components/ReportModal';
import SubscribeModal from './SubscribeModal';
import { Helmet } from 'react-helmet';
import { appName } from '../../constants/const';
import LastActiveBadge from '../../components/LastActiveBadge';
import { fetchFeed, deletePost, registeredCard } from 'reducers/feed/feed.actions';
import { selectFeed, selectIsFetchingFeed } from 'reducers/feed/feed.selectors';
import { getLaravelValidationErrors, isVideo } from '../../helpers';
import { NewBackIcon, SubscriptionIconPersonal, SubscriptionIcon } from '../../components/Icons';
import LockedSubscribeContent from './LockedSubscribeContent';
import Linkify from 'react-linkify';
import useToggle from 'utils/customHooks/useToggle';
import { ReactComponent as Logo } from '../../images/settings.svg';
import { ReactComponent as SearchLogo } from '../../images/search.svg';
import { ReactComponent as SendTipIcon } from '../../images/send-tip.svg';
import AddPaymentModal from 'components/AddPaymentModal';
import TipModal from '../../components/TipModal';
import PersonalModal from '../../components/PersonalModal';
import 'moment/locale/he';
import { ROOT } from '../../constants/routes';

const MAX_CHARS_POST_DESC = 120;


const Profile = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectAuthUser);
  const profile = useSelector(selectProfile);
  const isFetchingProfile = useSelector(selectIsFetchingProfile);
  const isFollowingProfile = useSelector(selectIsFollowingProfile);
  const match = useRouteMatch();
  const [isSubscribeOpen, setIsSubscribeOpen] = useState(false);
  const [filterValueParams, setFilterValueParams] = useState(false);
  const [subscribers, setSubscribers] = useState({});
  const { userId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [gridItems, setGridItems] = useState(false);
  const [profileVision, setProfileVision] = useState('');
  const [profileVisionId, setProfileVisionId] = useState('');
  const [profileInfo, setProfileInfo] = useState();
  const [showFullDesc, setShowFullDesc] = useToggle();
  const [buttonValue, setButtonValue] = useState();
  const [showPopUp, setShowPopUp] = useState(false);
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [subInfo, setSubInfo] = useState(null);
  const [userPhotoVideoObj, setUserPhotoVideoObj] = useState({});
  const [show, setShow] = useState(false);
  const [showCopyLink, setShowCopyLink] = useState(false);
  const [lastActive, setLastActive] = useState(null);
  const [isOnline, setIsOnline] = useState(null);
  const isHebrew = localStorage.getItem('current_language') === 'he';
  const feed = useSelector(selectFeed);
  const profileLastActive = useSelector(selectProfileLastActive);
  const [card, setCard] = useState(false);
  const [openTipModal, setOpenTipModal] = useState(false);
  const [openPersonalModal, setPersonalModal] = useState(false);
  const [openUnsubModal, setOpenUnsubModal] = useState(false);
  const [tipFlow, setTipFlow] = useState(false);
  const [showtip, setShowTip] = useState(false);
  const [personalTipFlow, setPersonalTipFlow] = useState(false);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const infoRef = useRef(null);

  const isMyProfile = useCallback(() => {
    if (currentUser) {
      if (userId && Number(userId) !== currentUser.id) return false;
      return true;
    }
    return false;
  }, [userId, currentUser]);

  const buttonGroup = [
    { name: `${t('feed')} ${userPhotoVideoObj?.posts || '0'}`, value: '1', vision: '' },
    { name: `${t('Photos')} ${userPhotoVideoObj?.images || '0'}`, value: '2', vision: 'photos' },
    { name: `${t('Videos')} ${userPhotoVideoObj?.videos || '0'}`, value: '3', vision: 'videos' },
  ];


  const onSubmit = () => {
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)

    if (!isFollowingProfile) {
      setShowPopUp(true);
    }


    if (!isLoading) {
      setIsLoading(true);
      setOpenTipModal(false)
      setOpenUnsubModal(false)
      dispatch(toggleFollow(user.id))
        .then(
          resp => {
            setIsLoading(false)
            setTimeout(() => {
              setShowPopUp(false);
            }, 3000);
            history.replace({ ...history.location, state: null })
            if (user.subscriptionPrice || isFollowingProfile) {

              dispatch(fetchProfile(userId || currentUser?.id))
                .then(res => {
                  setUserInfo(res)
                  setUser(res.user);
                  setLastActive(res.last_active);
                  setIsOnline(res.is_online);

                  setTimeout(() => {
                    setShowPopUp(false);
                  }, 3000);
                  if (res.following == true && res.following_till == null) {

                    dispatch(fetchProfileSubInfo(userId || currentUser?.id))
                      .then(
                        (res) => {
                          setSubInfo(res)



                        }
                      )
                  }
                })
                .catch(err => {
                  console.log('fetch user error', err);
                });
            }
          })
        .catch(err => {
          console.log('toggleFollow error', err);
          setErrors(getLaravelValidationErrors(err));
        })
        .finally(() => {
          setOpenTipModal(false)

        });
    }
  };

  useEffect(() => {
    if (history.location.state?.showSavePopup) {
      setShowSavePopup(true);

      setTimeout(() => {
        setShowSavePopup(false)
        history.replace({ ...history.location, state: null })
      }, 3000);
    }
  }, [])

  const handlePopUpClose = () => {
    setShowSavePopup(false)
  }
  useEffect(() => {
    if (history.location.state?.openTip && !isMyProfile() && history.location.state?.tipPayment != undefined) {
      setOpenTipModal(true)
    }
    else if (history.location.state?.openTip && !isMyProfile() && history.location.state?.personalTip) {
      setShowTip(true)
    }
    dispatch(registeredCard()).then(
      (resp) => {
        setCard(resp)

      }
    )

    if (!!currentUser) {
      dispatch(fetchProfileSubInfo(userId || currentUser?.id))
        .then(
          (resp) => {
            setSubInfo(resp)



          }
        )
      dispatch(fetchProfile(userId || currentUser?.id))
        .then(res => {
          setUserInfo(res)
          setUser(res.user);
          setLastActive(res.last_active);
          setIsOnline(res.is_online);
          if (res.following == true && res.following_till == null) {

            dispatch(fetchProfileSubInfo(userId || currentUser?.id))
              .then(
                (res) => {
                  setSubInfo(res)



                }
              )
              .catch(err => {

                console.log('sub error', err);
              });
          }
        })
        .catch(err => {
          setErrors(getLaravelValidationErrors(err));

          console.log('fetch user error', err);
        });
    }
    if (currentUser.id || userId) {
      dispatch(fetchProfileSubs(userId || currentUser.id))
        .then(res => {
          setUserPhotoVideoObj(res);
        })
        .catch(err => {
          console.log('fetch user error', err);
        });
    }
  }, [userId, currentUser.id]);
  
  useEffect(() => {
    const filterId = new URLSearchParams(location.search).get('filterId');


    const newValue = filterId || '1';

    setProfileVisionId(newValue)
    setButtonValue(newValue);
    setProfileVision(buttonGroup.find(item => item.value === newValue).vision)
  }, [])

  useEffect(() => {
    if (USER_PROFILE === match.path && !isFollowingProfile) {
      dispatch(fetchFeed(userId));
    }
  }, [USER_PROFILE, match.path, isFollowingProfile]);

  useEffect(() => {
    if (location.state && location.state.action) {
      if (location.state.action === 'subscribeModal') {
        setIsSubscribeOpen(true);
      }
    }

    //fetch viewing user data
    // if (!isMyProfile() || (userId && (!profile || profile.id !== Number(userId)))) {
    //   dispatch(fetchProfile(userId)).
    //   then(reps=> console.log(reps))
    //   .catch(err => {
    //     console.log('fetch user error', err);
    //   });
    // }
  }, [location]);

  useEffect(() => {
    if (openUnsubModal) {
      document.body.style.top = `-${window.scrollY}px`
      document.body.style.position = 'fixed'
      document.querySelector('html').style.height = `${window.innerHeight - 1}px`;
    }
    else {
      document.body.style.position = ''
      document.body.style.top = ''
      document.querySelector('html').style.height = '';

    }
  }, [openUnsubModal])

  const handleClose = () => {
    setOpenUnsubModal(false)
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  };


  const MoreMenuBtn = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <DotsIcon style={{ transform: 'rotate(90deg)' }} fill="#fff" width={24}>
        {children}
      </DotsIcon>
    </div>
  ));
  const callback = useCallback(bar => {
    setProfileInfo(bar);
  }, []);

  const FollowBtn = ({ style }) => {
    return (
      <Button
        disabled={userInfo.user.verification_status !== "verified"}
        onClick={!isFollowingProfile ? () => setOpenTipModal(true) : onSubmit}
        className={'profile-sub-btn btn btn-light px-5 mt-0 ' + (isFollowingProfile ? '' : 'unfollowing')}
        style={{ width: '100%', borderRadius: '32px' }}
      >
        <span className="personal-profile-sub-icon profile-sub-icon">
          <SubscriptionIcon />
        </span>
        {t(isFollowingProfile ? 'Unsubscribe' : 'subscribe_to_see_post')}
      </Button>
    );
  };

  const [profileTop, setProfileTop] = useState()

  const listenScrollEvent = (event) => {
    if (window.scrollY < 90) {
      return setProfileTop("transparent-top")
    } else if (window.scrollY > 90) {
      return setProfileTop("dark-top")
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
  }, []);

  const clickHandler = () => {
    if (history.location.state?.postPage || history.location.state?.openTip) {

      history.push(ROOT);
    }
    else {

      history?.goBack();
    }
  };

  const copyToClipboard = (user) => {
    let textField = document.createElement('textarea');
    textField.innerText = window.location.href.replace(window.location.pathname, '') + `/u/${user.id}/${user.nickname}`;
    if(textField.innerText.includes("filterId")){
      textField.innerText = textField.innerText.replace(`?filterId=${profileVisionId}/`, '/');
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
    }
    else{
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
    }
    setShowCopyLink(true);
    setTimeout(() => {
      setShowCopyLink(false);
    }, 2000);
  };
  const handtePersonalTipFlow = () => {
    setPersonalTipFlow(true)
    setPersonalModal(true)
  }
  const handteTipFlow = () => {
    setOpenTipModal(true)
    setTipFlow(true)
  }
  const pickButton = (value) => {
    setButtonValue(value);
    history.push({
      search: "?" + new URLSearchParams({ filterId: value }).toString(),
      state: {
        update: false
      }
    });
  }

  const isLong = (user?.about?.length  > MAX_CHARS_POST_DESC) || (infoRef.current?.offsetHeight >= 60);


  const handlePostDelete = async (id) => {
    if (window.confirm(t('This action can not be undone. Are you sure you want to delete this post?'))) {
      setIsLoading(true);
      await dispatch(deletePost(id)).finally(() => {
        setIsLoading(false);
      });
      await dispatch(fetchProfileSubs(userId || currentUser.id))
        .then(res => {
          setUserPhotoVideoObj(res);
        })
        .catch(err => {
          console.log('fetch user error', err);
        });
    }
  };
  let newDate = moment(userInfo?.following_till).format("MMM D")
  let newDateSub = new Date(subInfo?.nextChargeDate)
  let subscriptionEndDate = moment(subInfo?.nextChargeDate).format("MMM D yy")
  let newDateYear = moment(userInfo?.following_till).format("YYYY")
  //NOTE: renders  twice :/

  const noVideo = userPhotoVideoObj?.videos === 0 && profileVision === 'videos' && <p className='no-video-photo'>{t('Artist has not Video post yet')}</p>

  const noPhoto = userPhotoVideoObj?.images === 0 && profileVision === 'photos' && <p className='no-video-photo'>{t('Artist has not Photo post yet')}</p>

  return (
    <div className={`col profile-cont p-0  ${(noVideo || noPhoto) && 'pb-5'}`}>
      {showCopyLink && (
        <div className="clipboard copy-link-container" >
          <p className="profile-elipse-wrapper-text clipboard-text copy-text ">{t('Link to profile was copied to clipboard!')}</p>
          <span className="close-icon" onClick={() => setShowCopyLink(false)}>
            <CloseModalIcon fill="#fff" style={{ width: '12px' }} />
          </span>
        </div>
      )}
      {openUnsubModal && openUnsubModal &&

        <div className="card-popup-wrapper">

          <div className="unsub-modal-container ">

            <h2>{t('Subscription')}</h2>
            <p>{t('Disable renewal, your subscription will expire on')} {subInfo && subInfo.nextChargeDate ? <span>{subscriptionEndDate}</span> : ''}</p>
            <div>
              <Button onClick={handleClose}>{t('Back')}</Button>
              <Button onClick={onSubmit}>{t('Unsubscribe')}</Button>
            </div>
          </div>
        </div>
      }
      {showSavePopup && (
        <div className="popup-container">
          <div className="save-popup">
            <p className="save-popup-text">{t('Changes were saved')}</p>
            <BigXCloseBtn onClick={handlePopUpClose} className="x-icon " />
          </div>
        </div>
      )}
      <Loader isLoadin={isFetchingProfile || (user && user.subscriptionPrice && isLoading)} size={60}>
        {!!user && (
          <>
            <Helmet>
              <title>{appName + ' | ' + user.name}</title>
            </Helmet>
            <div
              className="profile-header d-flex flex-column justify-content-between"
              style={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%), url('${user.cover}')`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            >
              <div className={`${profileTop} profile-head`}>
                <div className="d-flex align-items-center" >
                  <NewBackIcon onClick={clickHandler} />
                  <div className={`ml-4 ${isHebrew ? "mr-2" : " "} `}>
                    <div className="d-flex align-items-center">
                      <h5 className="text-light-gray d-flex profile-head-user profile-head-user-wrap align-items-center m-0">
                        {user.name}
                      </h5>
                      {user.verification_status === "verified" && (
                        <VerifiedIcon height="1rem" width="1rem" className={`personal-page-verivication fill-white ${isHebrew ? "mr-2" : " "}`} style={{ transform: isHebrew ? 'rotate(00deg)' : 'rotate(0deg)' }} />
                      )}
                    </div>
                    <div className="d-flex align-items-center">
                      <h5 className="text-white m-0 mr-2 profile-head-info">
                        {userPhotoVideoObj ? userPhotoVideoObj.posts : 0} {t('posts')}
                      </h5>
                      <p className={`profile-dot mt-1 ${isHebrew ? "mr-1" : " "} `}></p>
                      <div className="d-flex profile-head-info ml-2">
                        <p className="profile-subscribers-amount">{subscribers ? subscribers.subscribing : 0}</p>
                        <p className={`profile-subscriber-text ${isHebrew ? "mr-1" : " "} `}>{`${userPhotoVideoObj.likes} ${t('likes')}`}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  {!isMyProfile() && currentUser && (
                    <div className="ml-auto  cursor-pointer">
                      <Dropdown alignRight={true}>
                        <Dropdown.Toggle as={MoreMenuBtn}></Dropdown.Toggle>
                        <Dropdown.Menu className="profile-dropdown">

                          <Dropdown.Item onClick={() => copyToClipboard(user)}>
                            {t('Copy Profile Link')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className=" col-md-9 col-12" style={{ marginTop: '-60px', padding: 0 }}>
              <div className="d-flex flex-column" style={{ padding: '0 16px' }}>
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ position: 'relative', top: '15px' }}
                >
                  <Avatar
                    user={user && user.name}
                    size={96}
                    className="mb-2"
                    image={user.avatar}
                    style={{
                      backgroundSize: 'cover',
                      height: '96px',
                      width: '96px',
                      border: '2px solid #070E19',
                      borderRadius: '50px ',
                      fontSize: '38.4px',
                      left: '-9px',
                      top: '5px',
                    }}
                  >
                    <LastActiveBadge lastActive={lastActive} isOnline={isOnline} />
                  </Avatar>
                  <div className="d-flex align-items-center profile-actions-wrapper">
                    {isMyProfile() && (
                      <div className="profile-edit">
                        <button onClick={() => history.push(SETTINGS)}>
                          <Logo />
                          <span>{t('edit_channel')}</span>
                        </button>
                      </div>
                    )}
                    {!isMyProfile() && isFollowingProfile && (
                      <div onClick={() => handtePersonalTipFlow()} className={`profile-copy-link ${isHebrew ? 'ml-2' : 'mr-2'}`}>
                        <SendTipIcon height={25} />
                      </div>
                    )}
                    <div className="profile-copy-link" onClick={() => copyToClipboard(user)}>
                      <CopyLinkIcon />
                    </div>
                  </div>
                </div>
                <h5 className="text-light-gray profile-head-user d-flex align-items-center mt-4">
                  {user.name}
                  {user.verification_status === "verified" && <VerifiedIcon height="1rem" width="1rem" className="fill-white personal-page-verivication" />}
                </h5>
                <div className="d-flex align-items-center">
                  <span className="mr-2 profile-head-displayname">{user.nickname ? `@${user.nickname}` : null}</span>
                  <p className="profile-dot mr-2" style={{ backgroundColor: '#797f92' }}></p>
                  <span className="profile-head-displayname-last-seen">
                    {t(`Last seen`)} {profileLastActive && moment(profileLastActive).fromNow()}
                  </span>
                </div>
                {user?.about && (
                  <>
                    <span  className="post-description-wrapper" style={{ maxHeight: showFullDesc ? '100%' : '50px', marginTop: '20px' }}>
                      <div
                        ref={infoRef}
                        className={
                          'text-light-gray text-break post-description-wrapper-text ' +
                          ' ' +
                          (showFullDesc ? '' : 'ellipsis')
                        }
                      >
                        {showFullDesc ? user?.about : user?.about}
                      </div>
                    </span>
                    {isLong ? (
                      <span>
                        <span>
                          {showFullDesc && user.website && (
                            <a
                              href={user.website.search(/^http[s]?\:\/\//) === -1 ? 'http://' + user.website : user.website}
                              target="_blank"
                              rel="noreferrer"
                              className="profile-website link-span"
                            >
                              {user.website}
                            </a>
                          )}
                        </span>
                        <span
                          className="post-description-btn d-flex align-items-center"

                          onClick={setShowFullDesc}
                        >
                          {showFullDesc ? t('less_info') : t('more_info')}
                          {showFullDesc ? (
                            <DownArrow fill="#36CFFF" style={{ transform: 'rotate(180deg)', marginLeft: '14px' }} />
                          ) : (
                            <DownArrow fill="#36CFFF" style={{ marginLeft: '14px' }} />
                          )}
                        </span>
                      </span>
                    ) : null}
                  </>
                )}
                {!isLong && user.website && (
                  <a
                    href={user.website.search(/^http[s]?\:\/\//) === -1 ? 'http://' + user.website : user.website}
                    target="_blank"
                    rel="noreferrer"
                    className="profile-website link-span"
                  >
                    {user.website}
                  </a>
                )}
              </div>
              <div style={{ position: 'relative', padding: '0 16.5px' }}>
                {isMyProfile() ? (
                  <div style={{ position: 'absolute', right: 0, top: -70 }}>{/* <ProfileActionBtns /> */}</div>
                ) : (
                  <div className={isFollowingProfile && userInfo.following_till === null ? 'subscribed-box' : 'subscription-box'}>
                    {(!isFollowingProfile || userInfo.following_till != null) && <>
                      <div className="subscription-box-line"></div>
                      <p className="mb-3 h5 text-center profile-sub-text">{t('Subscription')}</p>
                    </>}

                    <Button
                      disabled={userInfo.user.verification_status !== "verified" || (!isFollowingProfile && feed.length == 0)}
                      onClick={!isFollowingProfile ? () => setOpenTipModal(true) : userInfo.following_till ? () => (handteTipFlow()) : (user.subscriptionPrice != null ? () => setOpenUnsubModal(true) : onSubmit)}
                      className={
                        'profile-sub-btn btn btn-light px-5 mt-0 ' + (isFollowingProfile && userInfo.following_till === null ? 'followed-profile-sub subscribed-btn' : 'unfollowing')
                      }>
                      {!isFollowingProfile && (
                        <span className="personal-profile-sub-icon profile-sub-icon">
                          <SubscriptionIcon />
                        </span>
                      )}
                      {isFollowingProfile && userInfo.following_till === null ? (
                        <div className="subscribed-profile">
                          <span>{t('SUBSCRIBED')}</span>
                        </div>
                      ) : (
                        <div className={userInfo.following_till != null ? 'folowing-renew' : 'isFollowingProfile-action-wrap'}>
                          <span>{isFollowingProfile ? t('RENEW') : t('SUBSCRIBE')}</span>   {user.subscriptionPrice > 0 ? <span className="per-month">{userInfo.following_till != null ? t('FOR ') + user.subscriptionPrice + '₪' : ('₪' + user.subscriptionPrice + " per month")}</span> : <span>{t('FOR FREE')}</span>}
                        </div>
                      )}
                    </Button>

                    {newDate && userInfo.following_till &&
                      <div className="user-follow-till">
                        <div>{t('month expires')}</div>
                        <div><span>{newDate} ,<span style={{ paddingLeft: '4px' }}>{newDateYear}</span></span></div>
                      </div>
                    }

                    {showPopUp && (
                      <div className="profile-subscription-popup">
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <Avatar
                              user={user && user.name}
                              size={96}
                              className="mb-2"
                              image={user.avatar}
                              style={{
                                backgroundSize: 'cover',
                                height: '40px',
                                width: '40px',
                                border: '2px solid #070E19',
                                borderRadius: '50px ',
                              }}
                            />
                            <div className="d-flex mt-2 ml-2 profile-elipse-wrapper">
                              <h5 className="text-white">{user.name}</h5>
                              <span className="ml-2 user-nickname text-light-gray">
                                {user.nickname ? `@${user.nickname}` : null}
                              </span>
                            </div>
                          </div>
                          <spna className="close-icon" onClick={() => setShowPopUp(false)}>
                            <CloseModalIcon fill="#fff" style={{ width: '12px' }} />
                          </spna>
                        </div>
                        <p className="profile-elipse-wrapper-text">{t('You have successfully subscribed!')}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <PersonalModal isFollowingProfile={isFollowingProfile} personalTipFlow={personalTipFlow} card={card} user={user} openPersonalModal={openPersonalModal} showTip={showtip} setShowTip={setShowTip} onHide={() => setOpenTipModal(false)} setPersonalModal={setPersonalModal} />
              {openTipModal && (
                <AddPaymentModal tipFlow={tipFlow} card={card} subInfo={subInfo} onSubmit={onSubmit} user={user} show={openTipModal} onHide={() => setOpenTipModal(false)} />)}

              <div className={`${isFollowingProfile && userInfo.following_till === null ? 'profile-statistic-container-subscribed' : 'profile-statistic-container'}`}>
                <h5 className="m-0 mr-2 profile-head-info">
                  {feed.length ? feed.length : 0}
                  <span>
                    {t(' posts')}
                  </span>
                </h5>
                <div className="d-flex align-items-center">
                  {!!profileVision && isFollowingProfile && (
                    <div onClick={() => setGridItems(pre => !pre)}>
                      {gridItems ? (
                        <GridIcon style={{ marginLeft: '10px' }} />
                      ) : (
                        <GridContentIcon style={{ marginLeft: '10px' }} />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className='filter-buttons-wrapper' style={{ marginBottom: '18px', padding: '0 15px' }}>
                {buttonGroup.map((btn, idx) => (
                  <ToggleButton
                    key={idx}
                    id={`radio-${idx}`}
                    className="search-button-to-filter btn mr-2"
                    type="radio"
                    variant="secondary"
                    name="radio"
                    value={btn.value}
                    checked={buttonValue === btn.value}
                    onChange={e =>
                      pickButton(e.currentTarget.value)
                    }
                    onClick={e => {
                      setGridItems(false);
                      setProfileVision(btn.vision);
                      setProfileVisionId(btn.value);
                    }}
                  >
                    {btn.name ? btn.name.split(' ').map(el => <span>{t(el.toLowerCase())}</span>) : btn.name}
                  </ToggleButton>
                ))}
              </div>
              {!isFetchingProfile &&
                (isFollowingProfile || isMyProfile() || (!!currentUser && currentUser.role <= 5)) ? (
                <div className="profile-home-content">
                  <Home
                    userPhotoVideoObj={userPhotoVideoObj}
                    handlePostDelete={handlePostDelete}
                    userId={user.id}
                    isFollowingProfile={isFollowingProfile}
                    filterValueParams={filterValueParams}
                    currentUser={currentUser}
                    profileVision={profileVision}
                    gridItems={gridItems}
                    style={{ maxWidth: '100%' }}
                    profileCallback={callback}
                  />
                </div>
              ) : (
                <>
                  {feed.length > 0 &&
                    feed.map((post, index) => (
                      <div key={index} className="profile-locked-content" style={{ padding: '0 15px' }}>
                        <>
                          <>
                            {!(profileVision === 'photos') && !(profileVision === 'videos') && !isFollowingProfile && (
                              <React.Fragment>
                                <LockedSubscribeContent
                                  FollowBtn={FollowBtn}
                                  MoreMenuBtn={MoreMenuBtn}
                                  userStatus={userInfo.user.verification_status}
                                  post={post}
                                  files={post.files}
                                  card={card}
                                  onSubmit={onSubmit}
                                />
                              </React.Fragment>
                            )}
                            <>
                              {!isFetchingProfile &&
                                (!isFollowingProfile || !!currentUser) &&
                                post?.files[0]?.mime_type === 'image' &&
                                post?.files.length > 0 &&
                                profileVision === 'photos' ? (
                                <LockedSubscribeContent
                                  FollowBtn={FollowBtn}
                                  MoreMenuBtn={MoreMenuBtn}
                                  userStatus={userInfo.user.verification_status}
                                  post={post}
                                  files={post.files}
                                  card={card}
                                  onSubmit={onSubmit}
                                />
                              ) : !isFetchingProfile &&
                                (!isFollowingProfile || !!currentUser) &&
                                post?.files[0]?.mime_type === 'video' &&
                                profileVision === 'videos' ? (
                                <LockedSubscribeContent
                                  FollowBtn={FollowBtn}
                                  MoreMenuBtn={MoreMenuBtn}
                                  userStatus={userInfo.user.verification_status}
                                  post={post}
                                  files={post.files}
                                  card={card}
                                  onSubmit={onSubmit}
                                />
                              ) : null}

                            </>
                          </>
                        </>
                      </div>
                    ))}

                  {noVideo || noPhoto}

                </>
              )}
            </div>
          </>
        )}
      </Loader>
      <SubscribeModal isOpen={isSubscribeOpen} setIsOpen={setIsSubscribeOpen} user={user} btn={false} />
    </div>
  );
};

export default Profile;
